import { render, staticRenderFns } from "./Taller.vue?vue&type=template&id=3406ee66"
import script from "./Taller.vue?vue&type=script&lang=js"
export * from "./Taller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports